var dados2 = [
  {
    "id": "1b88c195-1257-4ea6-be6e-1c7dc312c1cb",
    "coordinates": null,
    "icon_color": "#15803d",
    "specie": {
      "family": "Leguminosae – Caesalpinioideae",
      "food": "",
      "geographic_distribution": "Distribui-se na Mata Atlântica do Rio de Janeiro, também encontrada no sul da Bahia e Pantanal Mato-grossense.",
      "habitat": "Árvore de grande porte, nativa do Brasil.",
      "habits": "Floração de agosto até o final do verão, com inflorescências de flores amarelas.",
      "order": "",
      "curiosities": "Muito indicada para reflorestamento e preservação ambiental. Para arborização urbana ou paisagismo, deve-se avaliar o espaço para evitar problemas com fiação elétrica ou calçadas.",
      "image_url": "https://www.ibflorestas.org.br/lista-de-especies-nativas/sibipiruna?utm_source=google-ads&utm_medium=cpc&utm_campaign=nativas-desmembrado&keyword=planta%20sibipiruna&creative=467848540268&gad=1&gclid=Cj0KCQjwu-KiBhCsARIsAPztUF0CmhHaAZdkULESsgCjiyS-u7dev8pkRJknxr4Hz1skvD54AHcTbB4aAg7-EALw_wcB",
      "name": "Sibipiruna",
      "known_names": "Flor de pavão",
      "scientific_name": "Caesalpinia pluviosa (sinonímia) / Cenostigma pluviosum",
      "division": "Plantae",
      "reference": "IBFlorestas (2023). Espécies Nativas."
    }
  },
  {
    "id": "c8aacd89-7f3a-4311-8af8-d0fe1a0c7a9e",
    "coordinates": null,
    "icon_color": "#15803d",
    "specie": {
      "family": "Anacardiaceae",
      "food": "",
      "geographic_distribution": "Amazônia, Caatinga, Cerrado, Mata Atlântica, Pampa.",
      "habitat": "Árvore nativa.",
      "habits": "Florece em Julho e Agosto.",
      "order": "",
      "curiosities": "Espécie pioneira com dispersão anemocórica.",
      "image_url": "https://www.arvoresdobiomacerrado.com.br/site/2017/03/28/astronium-graveolens-jacq/",
      "name": "Guaritá",
      "known_names": "gibatão, aderno, pau-ferro, aroeirão, gonçalo-alves",
      "scientific_name": "Astronium graveolens",
      "division": "Plantae",
      "reference": "Árvores do Bioma Cerrado (2017)."
    }
  },
  {
    "id": "d7d1c3ce-fe58-447c-9856-a4fb9a6de771",
    "coordinates": null,
    "icon_color": "#15803d",
    "specie": {
      "family": "Annonaceae",
      "food": "",
      "geographic_distribution": "Nativa das regiões tropicais das Américas e do Caribe.",
      "habitat": "Árvore de até 8 metros de altura.",
      "habits": "Flores solitárias e frutos grandes (25–35 cm), com polpa esbranquiçada e ácida.",
      "order": "",
      "curiosities": "Espécie exótica com dispersão zoocórica.",
      "image_url": "https://hortodidatico.ufsc.br/graviola/",
      "name": "Graviola",
      "known_names": "Jaca do Pará, Jaca de pobre, araticum, araticum-de-comer",
      "scientific_name": "Annona muricata",
      "division": "Plantae",
      "reference": "Horto Didático UFSC (2023)."
    }
  },
  {
    "id": "d715c5ef-03a6-4cb9-ad55-05789c3e846f",
    "coordinates": null,
    "icon_color": "#15803d",
    "specie": {
      "family": "Apocynaceae",
      "food": "",
      "geographic_distribution": "América do Sul.",
      "habitat": "Árvore nativa.",
      "habits": "Floração de setembro a janeiro.",
      "order": "",
      "curiosities": "Espécie em extinção no norte do Paraná e em Mato Grosso (categoria vulnerável). Madeira usada na construção civil e móveis.",
      "image_url": "https://www.arvoresdobiomacerrado.com.br/site/2017/04/17/aspidosperma-polyneuron-muell-arg/",
      "name": "Peroba rosa",
      "known_names": "amargoso, guatambu-amarelo, pau-caboclo, peroba-verdadeira",
      "scientific_name": "Aspidosperma polyneuron Mueller Arg.",
      "division": "Plantae",
      "reference": "Embrapa (2009), Árvores do Bioma Cerrado."
    }
  },
  {
    "id": "6e3978fd-8ae8-4390-b908-0026a1fcef84",
    "coordinates": null,
    "icon_color": "#15803d",
    "specie": {
      "family": "Apocynaceae",
      "food": "",
      "geographic_distribution": "Endêmica do Brasil. Ocorre no Cerrado e na Mata Atlântica.",
      "habitat": "Árvore de pequeno a médio porte.",
      "habits": "Floresce nos meses de outubro e novembro.",
      "order": "",
      "curiosities": "Pode ser usada em arborização de ruas estreitas e sob redes elétricas. Seus frutos atraem aves que consomem o arilo vermelho.",
      "image_url": "https://ferramentas.sibbr.gov.br/ficha/bin/view/especie/tabernaemontana_hystrix",
      "name": "Leiteiro",
      "known_names": "Pau-de-leite, jasmim do mato",
      "scientific_name": "Tabernaemontana hystrix Steud.",
      "division": "Plantae",
      "reference": "SiBBr (2023)."
    }
  },
  {
    "id": "62290964-2d53-4b1b-8ad4-a9afdd655bac",
    "coordinates": null,
    "icon_color": "#15803d",
    "specie": {
      "family": "Araucariaceae",
      "food": "",
      "geographic_distribution": "Sul do Brasil, locais de altitude no Sudeste, Argentina e Paraguai.",
      "habitat": "Árvore de grande porte, símbolo da região sul.",
      "habits": "Produz pinhas a partir de 12 a 20 anos.",
      "order": "",
      "curiosities": "Espécie vulnerável. Madeira de excelente qualidade. O pinhão é importante alimento humano e da fauna.",
      "image_url": "https://www.ufrgs.br/viveiroscomunitarios/araucaria-angustifolia-pinheiro-brasileiro",
      "name": "Araucária",
      "known_names": "Pinheiro do Paraná",
      "scientific_name": "Araucaria angustifolia (Bertol.) Kuntze",
      "division": "Plantae",
      "reference": "UFRGS (2023)."
    }
  },
  {
    "id": "710cc16f-b017-4e24-b8d5-6b1e5fdd558d",
    "coordinates": null,
    "icon_color": "#15803d",
    "specie": {
      "family": "Arecaceae",
      "food": "",
      "geographic_distribution": "Origem: Madagascar (África).",
      "habitat": "Palmeira ornamental, pode atingir até 12 m.",
      "habits": "Muito usada em jardins e paisagismo.",
      "order": "",
      "curiosities": "Espécie de vida longa, amplamente cultivada no paisagismo.",
      "image_url": "http://reflora.jbrj.gov.br/reflora/listaBrasil/ConsultaPublicaUC/BemVindoConsultaPublicaConsultar.do?...",
      "name": "Areca-bambu",
      "known_names": "Palmeira de jardim",
      "scientific_name": "Dypsis lutescens (H.Wendl.) Beentje & J.Dransf.",
      "division": "Plantae",
      "reference": "Reflora (2023)."
    }
  },
  {
    "id": "8d544f0c-6993-4879-b2e8-d8226e5e54dc",
    "coordinates": null,
    "icon_color": "#15803d",
    "specie": {
      "family": "Arecaceae",
      "food": "",
      "geographic_distribution": "Origem: Oceania.",
      "habitat": "Palmeira ornamental de porte pequeno.",
      "habits": "Folhas grandes e plissadas adaptadas para captar luz no interior da floresta.",
      "order": "",
      "curiosities": "Muito utilizada em vasos e ambientes internos.",
      "image_url": "https://projetojardinando.com.br/palmeira-leque/",
      "name": "Palmeira-leque",
      "known_names": "Licuala, Palmeira-licuala, Palmeira-liquala, Totuma, Licuala-grande, Palmeira-leque-japonês",
      "scientific_name": "Licuala grandis H. Wendl.",
      "division": "Plantae",
      "reference": "Projeto Jardinando (2023)."
    }
  },
  {
    "id": "315b6322-e368-4192-a374-a23c219de942",
    "coordinates": null,
    "icon_color": "#15803d",
    "specie": {
      "family": "Arecaceae",
      "food": "",
      "geographic_distribution": "Origem: Austrália, Oceania.",
      "habitat": "Palmeira de grande porte, 15–20 m.",
      "habits": "Floresce na primavera-inverno, frutificação no verão-outono.",
      "order": "",
      "curiosities": "Muito utilizada em arborização urbana e paisagismo.",
      "image_url": "https://www.scielo.br/j/rbb/a/wD7RvCHmqgSLpv7gMQcCdJq/?lang=pt",
      "name": "Palmeira real",
      "known_names": "Seafortia, Palmeira Real da Austrália",
      "scientific_name": "Archontophoenix cunninghamiana",
      "division": "Plantae",
      "reference": "SciELO (2023)."
    }
  },
  {
    "id": "5efdde4d-abb4-40e6-a0de-78898c17541a",
    "coordinates": null,
    "icon_color": "#15803d",
    "specie": {
      "family": "Arecaceae",
      "food": "",
      "geographic_distribution": "Nativa do Brasil: ES, RJ, MG, GO, MS até RS.",
      "habitat": "Palmeira nativa, comum em áreas abertas.",
      "habits": "Floresce o ano todo, frutos no outono-inverno-primavera.",
      "order": "",
      "curiosities": "Produz palmito de boa qualidade, de sabor amargo.",
      "image_url": "https://www.museunacional.ufrj.br/hortobotanico/Palmeiras/syagrusromanzoffiana.html",
      "name": "Jerivá",
      "known_names": "coqueiro-jerivá, coco-de-cachorro, baba-de-boi, coco-de-catarro, coco-babão, jerivá",
      "scientific_name": "Syagrus romanzoffiana (Cham) Glassman",
      "division": "Plantae",
      "reference": "Museu Nacional UFRJ (2023)."
    }
  },
  {
    "id": "cc8fce58-4ed3-468c-a82f-95e13eedd631",
    "coordinates": null,
    "icon_color": "#15803d",
    "specie": {
      "family": "Asparagaceae",
      "food": "",
      "geographic_distribution": "Origem: África, cultivada amplamente no Brasil.",
      "habitat": "Planta ornamental de interior e exterior.",
      "habits": "Floresce e frutifica ocasionalmente em plantas maduras.",
      "order": "",
      "curiosities": "Também conhecida como pau-d’água, é comercializada a partir de segmentos enraizados do tronco.",
      "image_url": "https://www.escoladebotanica.com.br/post/pau-dagua",
      "name": "Dracena",
      "known_names": "coqueiro-de-vênus, dragoeiro, cana-índia, pau-do-brasil",
      "scientific_name": "Dracaena fragrans",
      "division": "Plantae",
      "reference": "Escola de Botânica (2023)."
    }
  },
  {
    "id": "90c71e89-682d-4ba7-95aa-b4a78f9cc2bd",
    "coordinates": null,
    "icon_color": "#15803d",
    "specie": {
      "family": "Bixaceae",
      "food": "",
      "geographic_distribution": "Distribui-se naturalmente na Amazônia até a Bahia.",
      "habitat": "Árvore cultivada em muitas regiões do Brasil.",
      "habits": "Produz anualmente grande quantidade de sementes com propriedades condimentares e tintoriais.",
      "order": "",
      "curiosities": "Plantada em áreas degradadas de preservação permanente.",
      "image_url": "https://www.ibflorestas.org.br/lista-de-especies-nativas/urucum",
      "name": "Colorau",
      "known_names": "Urucum",
      "scientific_name": "Bixa orellana",
      "division": "Plantae",
      "reference": "IBFlorestas (2023)."
    }
  },
  {
    "id": "6a9b9335-5dea-4f22-a6e5-54ed68a588ee",
    "coordinates": null,
    "icon_color": "#15803d",
    "specie": {
      "family": "Bombacaceae",
      "food": "",
      "geographic_distribution": "Ampla distribuição na América do Sul: Amazônia, Caatinga, Cerrado, Mata Atlântica, Pampa, Pantanal.",
      "habitat": "Árvore de grande porte.",
      "habits": "Floração de fevereiro a maio.",
      "order": "",
      "curiosities": "Indicada para reflorestamento, preservação e arborização urbana. Deve-se avaliar o espaço para evitar problemas em calçadas e redes elétricas.",
      "image_url": "https://jb.utad.pt/especie/Ceiba_speciosa",
      "name": "Paineira",
      "known_names": "Paineira branca, paineira rosa, barriguda",
      "scientific_name": "Ceiba speciosa (A.St.-Hil.) Ravenna",
      "division": "Plantae",
      "reference": "Jardim Botânico UTAD (2023)."
    }
  },
  {
    "id": "5dca7f1a-3027-466c-a1da-727d8e9b4d32",
    "specie": {
      "name": "Perereca-do-brejo",
      "scientific_name": "Dendropsophus nanus",
      "family": "Hylidae",
      "habitat": "Ocorrem em poças temporárias permanentes, se localizam em áreas abertas, em brejos associados à florestas e áreas abertas naturais e antrópicas",
      "food": "Invertebrados pequenos como insetos, aranhas, ácaros e opiliões.",
      "habits": "Noturno. São anuros arborícolas, os machos formam arenas de exibição e vocalizam na vegetação marginal dos corpos d’água, geralmente em gramíneas e arbustos até 40 cm de altura. As fêmeas depositam ovos agrupados aderidos a plantas aquáticas.",
      "curiosities": "Espécie distribuída em região neotropical, do Norte da Argentina e Uruguai até o Sul do México.",
      "division": "1",
      "reference": "VAZ-SILVA, W. et al. Guia de identificação das espécies de anfíbios... 2020; ANTONIAZZI, C. E. et al. Alimentación de dos especies de anfibios... 2013."
    },
    "coordinates": [
      {
        "id": "50ba6977-5945-4709-acb5-97cff99b8395",
        "lat": -23.106667,
        "lng": -50.349444,
        "data": "03/06/2021"
      }
    ]
  },
  {
    "id": "84b1a98d-b387-4654-943f-08248488b68e",
    "specie": {
      "name": "Formiga-tartaruga",
      "scientific_name": "Cephalotes sp.",
      "family": "Formicidae",
      "habitat": "Normalmente são encontradas em árvores de grande porte, principalmente nas fendas das cascas.",
      "food": "São animais onívoros, possuem hábitos de comer lixo e até carniça.",
      "habits": "Diurnos. Possuem um sistema de defesa do ninho interessante, fechando a entrada com a cabeça onde há espinhos de defesa. As formigas possuem metamorfose completa.",
      "curiosities": "Ampla distribuição na América do Sul até países na América Central.",
      "division": "2",
      "reference": "Baccaro, Fabricio & Feitosa, Rodrigo & Fernández, Fernando... Guia para os gêneros de formigas do Brasil, 2015."
    },
    "coordinates": [
      {
        "id": "1127a403-4555-4b93-a7d2-fe11fb1cd744",
        "lat": -23.106389,
        "lng": -50.359444,
        "data": "03/06/2021"
      }
    ]
  },
  {
    "id": "b5e47f1f-5f61-4e9b-ad9f-f6908f747d04",
    "specie": {
      "name": "Beija-flor-dourado",
      "scientific_name": "Amazilia chrysura",
      "family": "Trochilidae",
      "habitat": "Florestas subtropicais ou tropicais úmidas de baixa altitude e savanas áridas.",
      "food": "Se alimenta do néctar das flores, mas come também pequenos artrópodes.",
      "habits": "Vive no interior e bordas das matas e cerradões, acostumando-se a frequentar jardins e áreas arborizadas de cidades.",
      "curiosities": "Encontrado em algumas partes do Brasil, também no Uruguai, Paraguai, Bolívia e Argentina.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil."
    },
    "coordinates": [
      {
        "id": "51b28b1a-7c47-4af2-91da-1d6bcd388c6a",
        "lat": -23.108333,
        "lng": -50.353333,
        "data": "08/10/2021"
      }
    ]
  },
  {
    "id": "ec8df615-dc60-4ebe-be19-191903c3075f",
    "specie": {
      "name": "Fim-fim",
      "scientific_name": "Euphonia chlorotica",
      "family": "Fringillidae",
      "habitat": "Habita a mata baixa e rala, o cerrado, a caatinga, cocais e matas serranas (região Sudeste).",
      "food": "Frugívoro. Visita áreas de vegetação mais densa na procura de insetos e frutos, sempre na parte alta da árvore ou arbustos maiores.",
      "habits": "Não se aproxima do chão na parte interna da ramagem, excelente dispersor de sementes.",
      "curiosities": "Ocorre em todas as regiões do Brasil.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil."
    },
    "coordinates": [
      {
        "id": "cf5c65ed-ff19-44bb-b41a-9c78548a63d2",
        "lat": -23.108056,
        "lng": -50.359722,
        "data": "21/10/2021"
      }
    ]
  },
  {
    "id": "492f6515-07ea-445c-af66-5cb48d28c32e",
    "specie": {
      "name": "Noivinha-branca",
      "scientific_name": "Xolmis irupero",
      "family": "Tyrannidae",
      "habitat": "É típica de áreas campestres, pousada em árvores isoladas, postes de eletricidade ou mourões de cerca.",
      "food": "Se alimenta principalmente de insetos capturados em voos curtos, mas também consome pequenos frutos.",
      "habits": "Vive solitária ou em casais, canto pouco notado, cantando mais de madrugada.",
      "curiosities": "Migratória. Ocorre da foz do Amazonas ao Paraná e Mato Grosso, com registros em Santa Catarina.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil."
    },
    "coordinates": [
      {
        "id": "ad38317f-7f61-4b1c-950b-cd8c4c4519ad",
        "lat": -23.110556,
        "lng": -50.3575,
        "data": "25/06/2021"
      }
    ]
  },
  {
    "id": "7840cec6-db10-4cda-a202-039e8ee04839",
    "specie": {
      "name": "Pica-pau-de-cabeça-amarela",
      "scientific_name": "Celeus flavescens",
      "family": "Picidae",
      "habitat": "Vive na Mata Atlântica, matas mesófilas, matas secas, matas de araucária, matas de galeria, caatinga, cerrados, eucaliptais, parques e zonas rurais arborizadas.",
      "food": "Insetívoro.",
      "habits": "Encontrado geralmente em casais ou em grupos familiares de 3 a 4 indivíduos. Constrói seu ninho em cavidades escavadas em formigueiros arborícolas e em árvores secas. O macho incuba e cuida dos filhotes.",
      "curiosities": "Ocorre da margem setentrional do baixo Amazonas ao Rio Grande do Sul, Paraguai e Argentina.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil."
    },
    "coordinates": [
      {
        "id": "94be15d6-ee34-476e-bc2a-4f2d542b6b1b",
        "lat": -23.108611,
        "lng": -50.359444,
        "data": "03/06/2021"
      }
    ]
  },
  {
    "id": "a53475d4-3dd0-43bf-99db-82a8bfc4abd4",
    "specie": {
      "name": "Pica-pau-do-campo",
      "scientific_name": "Colaptes campestris",
      "family": "Picidae",
      "habitat": "Habita campos e cerrados, vive em casais e, às vezes, em pequenos grupos.",
      "food": "Insetívoro. Costuma capturar insetos no solo, mas procura árvores ou pedras grandes para se proteger.",
      "habits": "Vive aos pares ou em pequenos bandos.",
      "curiosities": "Encontrado desde o nordeste do Brasil ao Uruguai, podendo ser avistado também no Paraguai, Bolívia, Argentina e baixo Amazonas.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil."
    },
    "coordinates": [
      {
        "id": "06a911b8-de38-4383-9c13-4dde539732fe",
        "lat": -23.110556,
        "lng": -50.359444,
        "data": "18/06/2021"
      }
    ]
  },
  {
    "id": "97866182-e1d0-4d1f-bf86-af4c1702788c",
    "specie": {
      "name": "Perereca-de-ampulheta",
      "scientific_name": "Dendropsophus minutus",
      "family": "Hylidae",
      "habitat": "Podem ser encontrados em mata de galeria, brejos associados às florestas e áreas abertas naturais e antropizadas.",
      "food": "Artrópodes de pequeno porte.",
      "habits": "Noturno. Machos vocalizam em ramos de vegetação marginal, arbustos, gramíneas e partes emersas de lagoas ou poças, principalmente de outubro a janeiro (estação chuvosa). Desovas diretamente na água.",
      "curiosities": "Ampla distribuição, desde áreas baixas à leste dos Andes da Colômbia até Brasil, Bolívia, Uruguai e Argentina.",
      "division": "1",
      "reference": "VAZ-SILVA, W. et al. Guia de identificação das espécies de anfíbios... 2020; LEIVAS, P. T. et al. Trophic niche of Dendropsophus minutus, 2018."
    }
  },
  {
    "id": "41f7d726-1490-4f2a-b393-76220b0983d8",
    "specie": {
      "name": "Perereca-cabrinha",
      "scientific_name": "Boana albopunctata",
      "family": "Hylidae",
      "habitat": "Adaptável a ambientes antrópicos, vistas sobre solo, lages emersas e vegetação herbácea ou arbustiva em margens de riachos permanentes ou temporários.",
      "food": "Aracnídeos e insetos, como borboletas e besouros.",
      "habits": "Noturno. Pequenas manchas amareladas na parte posterior da coxa.",
      "curiosities": "Ampla distribuição na América do Sul: nordeste da Argentina, norte do Uruguai, leste da Bolívia e Paraguai.",
      "division": "1",
      "reference": "VAZ-SILVA, W. et al. Guia de identificação das espécies de anfíbios... 2020; PACHECO, E. O. et al. Diet of Boana albopunctata, 2017."
    },
    "coordinates": [
      {
        "id": "071129b8-8cf7-4e5d-b4a6-bb7e3d2e9fc8",
        "lat": -23.106667,
        "lng": -50.349444,
        "data": "03/06/2021"
      }
    ]
  },
  {
    "id": "a69768c2-af97-4fb9-af1d-867af1c092dc",
    "specie": {
      "name": "Perereca-de-folhagem",
      "scientific_name": "Phyllomedusa tetraploidea",
      "family": "Phyllomedusidae",
      "habitat": "Áreas florestadas, florestas secundárias e pastagens.",
      "food": "Artrópodes de pequeno porte.",
      "habits": "Arborícola e noturno. Tanatose como defesa. Machos vocalizam e disputam fêmeas para reprodução. Desova em folhas enroladas.",
      "curiosities": "Distribuição: sudeste e sul do Brasil, Argentina e Paraguai.",
      "division": "1",
      "reference": "FISCH, F.; PORT, D. Localidades de ocorrência... 2013; PREUSS, J. F.; TOZETTI, A. M. Predation of Phyllomedusa tetraploidea, 2018."
    },
    "coordinates": [
      {
        "id": "bd80f033-2926-4c69-b209-fe2ad0b373a8",
        "lat": -23.108889,
        "lng": -50.359444,
        "data": "03/06/2021"
      }
    ]
  },
  {
    "id": "982add06-54a7-4d7d-82a7-2610f5dfcb97",
    "specie": {
      "name": "Teiú",
      "scientific_name": "Salvator merianae",
      "family": "Teiidae",
      "habitat": "Áreas abertas e bordas de mata.",
      "food": "Onívoro. Alimenta-se de frutas, ovos, larvas, insetos, pequenos vertebrados e carniça.",
      "habits": "Diurno, ativo, ectotérmico. Solta a cauda quando atacado (autonomia). Reprodução após a seca, ninhadas de 12 a 35 ovos.",
      "curiosities": "Distribuição do sul da Amazônia ao norte da Patagônia. Biomas: Caatinga, Cerrado, Mata Atlântica e Amazônia.",
      "division": "1",
      "reference": "Guia de répteis do Parque Estadual de Dois Irmãos / Ednilza Maranhão dos Santos, 2013."
    },
    "coordinates": [
      {
        "id": "af14a7f1-d2bc-4389-bdd4-fa38d0f3e9a5",
        "lat": -23.108889,
        "lng": -50.359444,
        "data": "03/06/2021"
      }
    ]
  },
  {
    "id": "b0b1b35c-8827-4f44-bc59-7e7059c52e80",
    "specie": {
      "name": "Urubu-preto",
      "scientific_name": "Coragyps atratus",
      "family": "Cathartidae",
      "habitat": "Campos naturais, borda de matas, áreas rurais e urbanas.",
      "food": "Detritívoro.",
      "habits": "Quando próximo a outros urubus, mantém a cauda ereta aparecendo entre as asas. Faz ninho em ocos de árvores mortas, entre pedras e locais abrigados. Põe 2 ovos branco-azulados manchados.",
      "curiosities": "Distribuição neoártica e neotropical: América do Norte, sul dos EUA, México, América Central e parte da América do Sul.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil."
    },
    "coordinates": [
      {
        "id": "7bc5b8cf-2140-439e-8a39-d29ec4726770",
        "lat": -23.107778,
        "lng": -50.359444,
        "data": "03/06/2021"
      }
    ]
  },
  {
    "id": "a4f5fbaa-1433-4db5-b923-290660e3e401",
    "specie": {
      "name": "Coruja-Buraqueira",
      "scientific_name": "Athene cunicularia",
      "family": "Strigidae",
      "order": "Strigiformes",
      "habitat": "Campos e áreas urbanas.",
      "food": "Insetos e pequenos vertebrados.",
      "habits": "Vive em ambientes abertos, terrícola, com hábitos diurnos e noturnos, mas é mais ativa durante o crepúsculo.",
      "curiosities": "Nidifica no solo, abrindo buracos onde colocam de 7 a 9 ovos. Filhotes atingem maturidade entre 49 a 56 dias. Reside no Brasil e na América do Sul.",
      "division": "1",
      "reference": "Menq, W. (2018) Coruja-buraqueira (Athene cunicularia) - Aves de Rapina Brasil. Disponível em: <http://www.avesderapinabrasil.com/athene_cunicularia.htm>"
    },
    "coordinates": [
      {
        "id": "cb31b28c-7790-4381-a45d-4428c7f05420",
        "lat": -23.108889,
        "lng": -50.358611,
        "data": "03/06/2021"
      }
    ]
  },
  {
    "id": "522d0509-7653-4d25-9e44-6624a95a80c2",
    "specie": {
      "name": "Vaquinha",
      "scientific_name": "Astylus variegatus",
      "family": "Melyridae",
      "order": "Coleoptera",
      "habitat": "Esse pequeno inseto pode ser encontrado sobre flores se alimentando de pólen.",
      "food": "Se alimentam de pólen das plantas, como girassol.",
      "habits": "Visitam flores de plantas silvestres e cultivadas, como algodoeiro, milho e sorgo, podendo causar danos aos órgãos florais.",
      "curiosities": "O período larval pode durar até um ano, período de pupa de 9 a 16 dias. Ocorre em Brasil, Paraguai e Argentina.",
      "division": "2",
      "reference": "BRUSCA, Ricardo C.; MOORE, Wendy; SHUSTER, Stephen M. Invertebrados, 3ª edição. Grupo GEN, 2018. ISBN 9788527733458. p. 795 - 839"
    },
    "coordinates": [
      {
        "id": "39f211e0-6c89-45f9-8354-822b62b9044b",
        "lat": -23.107222,
        "lng": -50.358889,
        "data": "03/06/2021"
      }
    ]
  },
  {
    "id": "1d084c61-0238-4e87-91af-7a8a8214c2a5",
    "specie": {
      "name": "Mariposa leopardo",
      "scientific_name": "Pantherodes pardalaria",
      "family": "Geometridae",
      "order": "Lepidoptera",
      "habitat": "São frequentemente encontrados em lugares úmidos.",
      "food": "Adultos são polinizadores; lagartas se alimentam de folhas.",
      "habits": "Principalmente noturnos, repousam com asas abertas em ambientes crípticos. Famílias geralmente têm 5 ou 6 ínstares.",
      "curiosities": "Ocorre do México à Argentina, no Brasil principalmente nas regiões sul e sudeste.",
      "division": "2",
      "reference": "BRUSCA, Ricardo C.; MOORE, Wendy; SHUSTER, Stephen M. Invertebrados, 3ª edição. Grupo GEN, 2018. ISBN 9788527733458. p. 795 - 839"
    }
  },
  {
    "id": "761a27c7-a12a-4083-b4ed-74e46f424032",
    "specie": {
      "name": "Piolho-de-cobra",
      "scientific_name": "Ommatoiulus sp.",
      "family": "Julidae",
      "order": "Julida",
      "habitat": "Rochas, serrapilheira e troncos em decomposição.",
      "food": "Detritívoros, alimentam-se de restos orgânicos de origem animal ou vegetal.",
      "habits": "Possuem hábitos crípticos, evitando luz. Podem se enrolar ou usar fluídos tóxicos como defesa.",
      "curiosities": "Ampla distribuição mundial, principalmente nos trópicos.",
      "division": "2",
      "reference": "BRUSCA, Ricardo C.; MOORE, Wendy; SHUSTER, Stephen M. Invertebrados, 3ª edição. Grupo GEN, 2018. ISBN 9788527733458. p. 843 - 856"
    }
  },
  {
    "id": "bf8e34e8-c7fe-423b-a631-978832c8fa6c",
    "specie": {
      "name": "Quati",
      "scientific_name": "Nasua nasua",
      "family": "Procyonidae",
      "order": "Carnivora",
      "habitat": "Florestas decíduas, semi-decíduas, ombrófilas, florestas nebulares, chaco xericó, cerrado e florestas secas.",
      "food": "Onívoro, se alimenta de frutos e invertebrados, e em áreas urbanas restos orgânicos.",
      "habits": "Diurno, terrestre e arborícola. Interage com aves e outras espécies, contribuindo para processos ecológicos.",
      "curiosities": "Distribuição: América do Sul, da Colômbia e Venezuela ao Uruguai até o Norte da Argentina.",
      "division": "1",
      "reference": "Emmons, L. & Helgen, K. 2016. Nasua nasua. The IUCN Red List of Threatened Species 2016: e.T41684A45216227. http://dx.doi.org/10.2305/IUCN.UK.20161.RLTS.T41684A45216227.en"
    },
    "coordinates": [
      {
        "id": "22485ccc-cdfd-4e29-8dc8-e60f7dcee4ab",
        "lat": -23.107778,
        "lng": -50.351944,
        "data": "15/06/2021"
      }
    ]
  },
  {
    "id": "0e2ed97e-ba74-4c45-933c-52e0f1749c13",
    "specie": {
      "name": "Tiziu",
      "scientific_name": "Volatinia jacarina",
      "family": "Thraupidae",
      "order": "Passeriformes",
      "habitat": "Áreas desprovidas de vegetação.",
      "food": "Principalmente sementes de gramíneas, ocasionalmente insetos.",
      "habits": "Salta enquanto canta. Na época reprodutiva reúne-se em bandos com outras aves de alimentação similar. Dimorfismo sexual presente.",
      "curiosities": "Distribuição: todo o Brasil e América do Sul.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "f137719f-229a-4c62-a28a-71d9a7e09991",
        "lat": -23.11,
        "lng": -50.3625,
        "data": "23/09/2021"
      }
    ]
  },
  {
    "id": "aeaffd17-6e6f-40dc-8a6d-49c07774bd5b",
    "specie": {
      "name": "Tesourinha",
      "scientific_name": "Tyrannus savana",
      "family": "Tyrannidae",
      "order": "Passeriformes",
      "habitat": "Áreas abertas, cerrados, ambientes urbanos e pastagens.",
      "food": "Insetos e frutos, principalmente no período de migração.",
      "habits": "Hábito de forragamento comum em Tyrannidae. Migra em grupos, pousa em postes e árvores isoladas. Dimorfismo sexual: macho com prolongamento maior nas caudas externas.",
      "curiosities": "Distribuição: Brasil, Argentina e Paraguai.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "d462357b-20c0-4bf9-affe-a0a09c5d1495",
        "lat": -23.107778,
        "lng": -50.359444,
        "data": "29/08/2021"
      }
    ]
  },
  {
    "id": "588ac637-f6a4-4d4a-bff4-79f974c51ccc",
    "specie": {
      "name": "Periquito-de-encontro-amarelo",
      "scientific_name": "Brotogeris chiriri",
      "family": "Psittacidae",
      "order": "Psittaciformes",
      "habitat": "Campos de vegetação baixa, ilhas de matas intercaladas, matas ciliares, cerrados e cerradões.",
      "food": "Néctar, cascas de árvores, sementes e frutos.",
      "habits": "Desloca-se em bandos numerosos. Atua como polinizador e predador de sementes.",
      "curiosities": "Distribuição: América do Sul, abundante nas regiões secas do Brasil.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "4a975bda-38c0-4152-b649-52aa2d04e41c",
        "lat": -23.110556,
        "lng": -50.362222,
        "data": "03/06/2021"
      }
    ]
  },
  {
    "id": "cab88192-c4fe-43aa-9d23-dd3eec1bd8b8",
    "specie": {
      "name": "Gavião-de-cauda-curta",
      "scientific_name": "Buteo brachyurus",
      "family": "Accipitridae",
      "order": "Accipitriformes",
      "habitat": "Campos com árvores, áreas florestadas permeadas de vegetação aberta e áreas urbanas.",
      "food": "Carnívoro, normalmente captura pequenas aves.",
      "habits": "Normalmente solitário, ocasionalmente aos pares. Passa a maior parte do dia planando em grande altitude.",
      "curiosities": "Exibições aéreas do macho acompanhadas de vocalizações. Ovos geralmente manchados de cor variável. Distribuição: Sul dos EUA, México, Argentina, Paraguai e todo o Brasil.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "426357da-0112-42e5-96ee-1133f2af8c2b",
        "lat": -23.108889,
        "lng": -50.358611,
        "data": "07/11/2021"
      }
    ]
  },
  {
    "id": "44a0d7b5-f5e6-4bcb-b0ba-f52c43b7bd39",
    "specie": {
      "name": "Irerê",
      "scientific_name": "Dendrocygna viduata",
      "family": "Anatidae",
      "order": "Anseriformes",
      "habitat": "Quase qualquer corpo d'água ao longo de sua ampla distribuição.",
      "food": "Granívoro, alimenta-se de plantas submersas e gramíneas; também come invertebrados aquáticos, pequenos peixes e girinos.",
      "habits": "Mais ativo nos crepúsculos e à noite. Forma bandos durante migrações. Construção de ninho no chão, com cuidados do macho e da fêmea aos filhotes.",
      "curiosities": "Distribuição: Brasil, África, Madagascar e Ilhas Comores.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "52575774-bf4a-4bd6-8e8e-4f7e1bd1a7f5",
        "lat": -23.108889,
        "lng": -50.354167,
        "data": "21/10/2021"
      }
    ]
  },
  {
    "id": "7929a2f9-4798-4766-a8a1-198758c49e0e",
    "specie": {
      "name": "Martim-pescador-verde",
      "scientific_name": "Chloroceryle amazona",
      "family": "Alcedinidae",
      "order": "Coraciiformes",
      "habitat": "Grandes rios, lagos, manguezais, margens de barrancos ou rochas onde possa nidificar.",
      "food": "Onívoro, alimenta-se principalmente de peixes.",
      "habits": "Voa rente ao espelho d’água, frequenta rios e lagos grandes. Durante reprodução, macho oferece alimento à fêmea e levanta asas como saudação. Casal permanece junto por anos.",
      "curiosities": "Distribuição: México à Argentina, todo o Brasil.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "b76afce2-15ff-48af-adac-640dd7baaa3d",
        "lat": -23.108889,
        "lng": -50.359167,
        "data": "25/06/2021"
      }
    ]
  },
  {
    "id": "6883779f-e7c4-4b01-b4b0-327a335156b5",
    "specie": {
      "name": "Sabiá-do-campo",
      "scientific_name": "Mimus saturninus",
      "family": "Mimidae",
      "order": "Passeriformes",
      "habitat": "Vive nas copas das árvores ou passa a maior parte do tempo no chão.",
      "food": "Onívoro, alimenta-se principalmente de invertebrados e frutos.",
      "habits": "De hábitos diurnos, andando pelo chão atrás de alimento. Apresenta o ‘lampejo de asas’, levantando asas semiabertas durante exibições ou ameaças.",
      "curiosities": "Distribuição: Regiões campestres do baixo Amazonas, Brasil central, Nordeste, Leste e Sul até Uruguai, Paraguai, Argentina e Bolívia.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "3997cd29-7176-4e2e-963d-1e16a9f651d3",
        "lat": -23.110556,
        "lng": -50.362222,
        "data": "03/06/2021"
      }
    ]
  },
  {
    "id": "07ef1d2b-d6c1-41b4-9d1d-fa2de54e4514",
    "specie": {
      "name": "Urubu-de-cabeça-vermelha",
      "scientific_name": "Cathartes aura",
      "family": "Cathartidae",
      "order": "Cathartiformes",
      "habitat": "Campos, matas e bosques.",
      "food": "Detritívoro.",
      "habits": "À noite dirige-se para pousos tradicionais, em árvores ou capões. Pousos podem ter 20 a 30 urubus de várias espécies. Não vocaliza. Proibido por lei no Brasil matar ou criar sem autorização do IBAMA.",
      "curiosities": "Distribuição: sul do Canadá até América do Sul.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "53c9618a-0395-49d4-8d31-3f00b2adcec1",
        "lat": -23.108889,
        "lng": -50.354167,
        "data": "24/09/2021"
      }
    ]
  },
  {
    "id": "1b35a92a-3506-4947-af5f-facd5df244e6",
    "specie": {
      "name": "Arapaçu-de-cerrado",
      "scientific_name": "Lepidocolaptes angustirostris",
      "family": "Dendrocolaptidae",
      "order": "Passeriformes",
      "habitat": "Vive no cerrado, na caatinga e em lugares abertos, com árvores esparsas.",
      "food": "Insetívoro, come principalmente formigas, besouros, lagartas de borboletas, além de aranhas e escorpiões.",
      "habits": "Sobe pelos troncos agarrado pelos pés, enfia o bico em fendas e por baixo das cascas, voa para a base de outra árvore e recomeça. Vive sozinho ou em casais.",
      "curiosities": "Nidifica em árvores velhas, usando ocos abandonados por pica-paus, reveste a cavidade com folhas e cascas e põe dois ovos branco-puros. Distribuição: Suriname, Uruguai, Argentina, Paraguai, Bolívia e Brasil extra-amazônico.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "3882eb58-24df-4154-84f2-a6854251d424",
        "lat": -23.110556,
        "lng": -50.362222,
        "data": "03/06/2021"
      }
    ]
  },
  {
    "id": "2f70e816-ee29-48d0-bd50-6041a4043130",
    "specie": {
      "name": "Avoante",
      "scientific_name": "Zenaida auriculata",
      "family": "Columbidae",
      "order": "Columbiformes",
      "habitat": "Originalmente ave campestre típica da caatinga, cerrado e campos, atualmente adaptada a ambientes urbanos.",
      "food": "Granívoro, alimenta-se de grãos silvestres e brotos de plantações.",
      "habits": "Migratória no nordeste do Brasil. População urbana em expansão desde 1970.",
      "curiosities": "Muito prolífica. Distribuição: todo o Brasil.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "ffb50a36-8d5a-45bb-bce3-40a03e0b5e09",
        "lat": -23.107778,
        "lng": -50.359444,
        "data": "03/06/2021"
      }
    ]
  },
  {
    "id": "66658b88-4832-452a-8986-53eeebda42ce",
    "specie": {
      "name": "Bico-de-lacre",
      "scientific_name": "Estrilda astrild",
      "family": "Estrildidae",
      "order": "Passeriformes",
      "habitat": "Comum em campos e terrenos baldios nas cidades.",
      "food": "Granívoro, alimenta-se de sementes de gramíneas africanas e ocasionalmente pequenos insetos.",
      "habits": "Vive em bandos pequenos e grandes, aproveita poças de água para banho. Vive perto de plantas aquáticas ou margens de rios.",
      "curiosities": "Originário da África, introduzido no Brasil durante o reinado de D. Pedro I. Distribuição: praticamente todo o território brasileiro.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "7f95f7a8-8ca9-4ac5-968b-6bcb82a2de33",
        "lat": -23.108611,
        "lng": -50.359444,
        "data": "20/11/2021"
      }
    ]
  },
  {
    "id": "0dcb2386-d8cd-4363-a300-1924bfe6681d",
    "specie": {
      "name": "Carcará",
      "scientific_name": "Caracara plancus",
      "family": "Falconidae",
      "order": "Falconiformes",
      "habitat": "Áreas abertas como savanas, campos e banhados.",
      "food": "Onívoro, alimenta-se de animais vivos ou mortos e lixo produzido por humanos.",
      "habits": "Vive solitário, aos pares ou em grupos. Pousa em árvores, cercas e queimadas. Durante o dia, pousa em galhos altos.",
      "curiosities": "Chamada ‘carcará’ usada para comunicação entre casal e outros carcarás. Distribuição: Argentina até sul dos EUA.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "a0c1798e-4d0c-4cc3-b054-f63096abb8b5",
        "lat": -23.107778,
        "lng": -50.359444,
        "data": "04/06/2021"
      }
    ]
  },
  {
    "id": "b80e6c4e-f875-4d91-b824-26ff68c293b9",
    "specie": {
      "name": "Falcão-de-coleira",
      "scientific_name": "Falco femoralis",
      "family": "Falconidae",
      "order": "Falconiformes",
      "habitat": "Espécie campestre, ocorre em campos, cerrados, cerradões, bosques abertos, áreas agrícolas e urbanas.",
      "food": "Insetos, cupins, lagartixas, morcegos e ocasionalmente pássaros e cobras peçonhentas.",
      "habits": "Costuma pousar em árvores baixas, mourões e cupinzeiros. Não constrói ninhos próprios.",
      "curiosities": "Distribuição: Estados Unidos até todo o Brasil.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "4ac98692-9e57-462f-a902-d49739608848",
        "lat": -23.111389,
        "lng": -50.3575,
        "data": "28/08/2021"
      }
    ]
  },
  {
    "id": "0008e4a0-c203-4084-9d38-3e60d2d34764",
    "specie": {
      "name": "Chupim-do-brejo",
      "scientific_name": "Pseudoleistes guirahuro",
      "family": "Icteridae",
      "order": "Passeriformes",
      "habitat": "Brejos e várzeas com capim alto, geralmente em bandos.",
      "food": "Grãos e sementes.",
      "habits": "Alguns indivíduos cantam juntos, pousados próximos uns dos outros.",
      "curiosities": "Nidificação em colônias, geralmente em áreas úmidas, duas vezes por temporada de reprodução. Distribuição: sul do Mato Grosso, Mato Grosso do Sul, Goiás, DF, SP, PR, SC, RS, RJ e MG.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "b75cc19d-d576-4831-b9fa-0cd3bfa88deb",
        "lat": -23.108889,
        "lng": -50.354167,
        "data": "25/06/2021"
      }
    ]
  },
  {
    "id": "21a7026c-cad5-43d0-9c86-4523ab573b21",
    "specie": {
      "name": "Mariquita",
      "scientific_name": "Setophaga pitiayumi",
      "family": "Parulidae",
      "order": "Passeriformes",
      "habitat": "Copa das árvores mais altas de mata seca e cerradões, ocasionalmente estratos mais baixos em bordas e clareiras.",
      "food": "Insetívoro.",
      "habits": "Vive em casais ou solitária, acompanha bandos mistos ou caça por conta própria, canto incessante.",
      "curiosities": "Apesar de cores vibrantes, pode passar despercebida. Canto serve como contato entre membros do casal. Distribuição: alguns estados do Brasil, sul dos EUA, Bolívia, Paraguai, Argentina e Uruguai.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "6d632be7-9569-4125-848b-9fd33054fc68",
        "lat": -23.110556,
        "lng": -50.362222,
        "data": "23/09/2021"
      }
    ]
  },
  {
    "id": "7d04fdd5-2fc9-48d7-a408-3bf12a00312f",
    "specie": {
      "name": "Pardal",
      "scientific_name": "Passer domesticus",
      "family": "Passerídae",
      "order": "Passeríformes",
      "habitat": "Comum na maioria dos habitats, abundante em ambientes antrópicos.",
      "food": "Frutos, sementes, flores, insetos e restos de alimentos humanos.",
      "habits": "Formam grandes bandos, forrageiam no solo e voam com voo direto agitando asas.",
      "curiosities": "Dimorfismo sexual: machos com bico preto e coloração cinza-claro ou branca no rosto; fêmeas marrons com listra supraciliar clara. Distribuição: todo território brasileiro.",
      "division": "1",
      "reference": "GHERARD, B. Maciel, R. Guia de Aves. Fundação Ezequiel Dias. Belo Horizonte: Imprensa Oficial, 2015. p.61"
    },
    "coordinates": [
      {
        "id": "03b8cb64-8eef-427b-898a-909896c4a499",
        "lat": -23.108889,
        "lng": -50.359444,
        "data": "03/06/2021"
      }
    ]
  },
  {
    "id": "c6e1b234-9675-45a2-983f-f1b549fa560b",
    "specie": {
      "name": "Polícia-inglesa-do-sul",
      "scientific_name": "Leistes superciliaris",
      "family": "Icteridae",
      "order": "Passeriformes",
      "habitat": "Zonas úmidas e palustres, fácil de encontrar em plantações de arroz.",
      "food": "Larvas, insetos e várias sementes.",
      "habits": "Levanta-se em voo vertical sobre o ninho cantando, comportamento similar às cotovias. Nidifica no chão, em moitas de capim.",
      "curiosities": "Dimorfismo sexual. Distribuição: quase todo o Brasil extra-amazônico.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "0eb39b0c-5fac-4684-8f40-22c49d28bb2e",
        "lat": -23.108889,
        "lng": -50.359167,
        "data": "17/07/2021"
      }
    ]
  },
  {
    "id": "30506cf9-5a1c-4830-a8fe-5f5bf85d414f",
    "specie": {
      "name": "Tico-tico",
      "scientific_name": "Zonotrichia capensis",
      "family": "Passerellidae",
      "order": "Passeriformes",
      "habitat": "Paisagens abertas, plantações, jardins, pátios e coberturas ajardinadas, abundante em regiões de clima temperado e cumes altos.",
      "food": "Sementes, brotos, frutas e insetos.",
      "habits": "Vive em casais isolados; macho defende território atacando vizinhos. Escava alimento no solo com pequenos pulos.",
      "curiosities": "Distribuição: todas as regiões do Brasil (exceto áreas florestadas da Amazônia), México, Panamá e maior parte da América do Sul.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "51476b08-6d7a-4061-a1fd-b926f3fdf757",
        "lat": -23.108611,
        "lng": -50.359444,
        "data": "29/07/2021"
      }
    ]
  },
  {
    "id": "b2408ec7-566f-4c81-b4e4-dee45caad908",
    "specie": {
      "name": "Tico-tico-do-campo",
      "scientific_name": "Ammodramus humeralis",
      "family": "Passerellidae",
      "order": "Passeriformes",
      "habitat": "Campos secos com gramíneas, cerrados, terrenos cultivados e locais com moitas de capim alto.",
      "food": "Sementes e pequenos insetos.",
      "habits": "Corre e pula silenciosamente por entre as gramíneas. Na reprodução, forma casais com território bem definido. Quando assustado corre entre folhas, voa pouco e pousa rapidamente.",
      "curiosities": "Distribuição: todo o Brasil e outros países da América do Sul, exceto Equador e Chile.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "38bc8156-ef4f-47bb-9555-845f27624b69",
        "lat": -23.108611,
        "lng": -50.359444,
        "data": "23/09/2021"
      }
    ]
  },
  {
    "id": "ba3779b1-58f5-426d-9bbe-98d60a1a2523",
    "specie": {
      "name": "Urutau",
      "scientific_name": "Nyctibius griséus",
      "family": "Nyctibiidae",
      "order": "Nyctibiiformes",
      "habitat": "Comum em bordas de florestas, campos com árvores e cerrados.",
      "food": "Insetívoro, se alimenta de insetos noturnos.",
      "habits": "Pousa em locais abertos, permanece disfarçado e canta à noite.",
      "curiosities": "O nome urutau é tupi e significa “ave fantasma”. Distribuição: Brasil, Costa Rica, Bolívia, Argentina e Uruguai.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "b0bf9740-70d3-4843-a68c-d2179d04bd02",
        "lat": -23.108056,
        "lng": -50.359722,
        "data": "06/10/2021"
      }
    ]
  },
  {
    "id": "3fa2a8b4-4e82-44ec-9726-0b0773a1c4f4",
    "specie": {
      "name": "Ferreirinho-relógio",
      "scientific_name": "Todirostrum cinereum",
      "family": "Rhynchocyclidae",
      "order": "Passeriformes",
      "habitat": "Característico de ambientes mais abertos, comum em cidades, ausente de áreas florestadas extensas.",
      "food": "Insetívoro.",
      "habits": "Vive escondido na vegetação baixa, movimenta a cauda lateralmente e casal responde a gravações de canto.",
      "curiosities": "O canto lembra o tique-taque de um relógio de mesa. Distribuição: sul do México até Argentina, ausente na Amazônia florestal.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "309c1b43-dc8c-4952-a555-5686824cd956",
        "lat": -23.110556,
        "lng": -50.362222,
        "data": "24/06/2021"
      }
    ]
  },
  {
    "id": "18b16ac0-9cf5-445e-8511-68db5d69626c",
    "specie": {
      "name": "Papagaio-verdadeiro",
      "scientific_name": "Amazona aestiva",
      "family": "Psittacidae",
      "order": "Psittaciformes",
      "habitat": "Florestas úmidas, savanas, florestas de galeria, áreas cultivadas com árvores e matas com palmeiras.",
      "food": "Sementes e frutos.",
      "habits": "Comum em casais ou bandos.",
      "curiosities": "Devido ao dom da fala, é muito procurado como ave de estimação, sofrendo captura clandestina. Distribuição: interior da América do Sul, nordeste do Brasil, leste da Bolívia, Paraguai e norte da Argentina.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "abeeba6f-37e0-42bd-ad64-6c4062396a1b",
        "lat": -23.108611,
        "lng": -50.359444,
        "data": "15/07/2021"
      }
    ]
  },
  {
    "id": "20ca4d4c-6449-402b-98e1-4f7131133fbe",
    "specie": {
      "name": "Periquitão",
      "scientific_name": "Psittacara leucophthalmus",
      "family": "Psittacidae",
      "order": "Psittaciformes",
      "habitat": "Florestas úmidas e semi-úmidas, pântanos, florestas de galeria e palmares de buriti em planícies, não frequenta rios de águas escuras.",
      "food": "Frutos e sementes.",
      "habits": "Voa em bandos de 5 a 40 indivíduos, dorme coletivamente, adaptável a ambientes alterados pelo homem.",
      "curiosities": "Distribuição: quase todo o Brasil, leste dos Andes, Colômbia, Venezuela, norte da Argentina e Uruguai.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "46c3524c-809c-4293-970c-6a9d8bad7d79",
        "lat": -23.110556,
        "lng": -50.362222,
        "data": "03/06/2021"
      }
    ]
  },
  {
    "id": "bcded3a1-3c11-4e48-aec2-1557c5477c38",
    "specie": {
      "name": "Pica-pau-anão-escamado",
      "scientific_name": "Picumnus albosquamatus",
      "family": "Picidae",
      "order": "Piciformes",
      "habitat": "Ambientes com árvores e arbustos, especialmente matas ciliares, cerradões e matas.",
      "food": "Insetívoro.",
      "habits": "Acompanha bandos mistos, movimenta-se aos saltos alternando o pé de apoio. Empoleira tanto na vertical quanto na horizontal.",
      "curiosities": "Distribuição: alguns estados brasileiros.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "9cd1a0bf-53e2-4626-a715-52b35b673302",
        "lat": -23.108333,
        "lng": -50.353333,
        "data": "24/09/2021"
      }
    ]
  },
  {
    "id": "7ee3aec9-07f4-4d05-a4bc-da562c02de84",
    "specie": {
      "name": "Pica-pau-branco",
      "scientific_name": "Melanerpes candidus",
      "family": "Picidae",
      "order": "Piciformes",
      "habitat": "Áreas campestres, pastos, eucaliptais, capoeiras ralas, buritizais, plantações, áreas rurais, cidades, parques e bordas de brejos arborizados.",
      "food": "Insetos, larvas, sementes e frutos.",
      "habits": "Grupos de 6 a 20 indivíduos, dormindo em ocos de árvores, às vezes associados a outras aves campestres.",
      "curiosities": "Voam em grandes alturas buscando novos ambientes. Distribuição: todo o Brasil, Suriname, Bolívia, Argentina, Paraguai e Uruguai.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "d257771c-512e-417b-b9cc-a058a2dc4a03",
        "lat": -23.110556,
        "lng": -50.362222,
        "data": "15/07/2021"
      }
    ]
  },
  {
    "id": "e54eeb79-7105-4d7e-93f3-ad8b10c2e0c3",
    "specie": {
      "name": "Pica-pau-de-banda-branca",
      "scientific_name": "Dryocopus lineatus",
      "family": "Picidae",
      "order": "Piciformes",
      "habitat": "Interior e bordas de florestas altas, capoeiras, cerrados, campos e plantações com árvores esparsas.",
      "food": "Insetívoro.",
      "habits": "Vive solitário ou aos pares, martelando troncos em busca de insetos. Recolhe-se cedo para dormir.",
      "curiosities": "Distribuição: todo o Brasil, México, Bolívia, Paraguai e Argentina.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "1f65ab12-82fa-464d-9543-1a63d936ff6d",
        "lat": -23.108611,
        "lng": -50.359444,
        "data": "03/06/2021"
      }
    ]
  },
  {
    "id": "2cf3870d-9e3f-43ac-9c4b-6efd71627509",
    "specie": {
      "name": "Pica-pau-pequeno",
      "scientific_name": "Veniliornis passerinus",
      "family": "Picidae",
      "order": "Piciformes",
      "habitat": "Áreas abertas, clareiras, bordas de matas secas, caatingas, cerrados, matas de galeria, várzeas e terra firme, também mata secundária, ripária, mangues e zonas rurais.",
      "food": "Insetívoro.",
      "habits": "Solitário, aos pares ou em grupos familiares. Muito arisco, movimenta-se rapidamente pelas copas.",
      "curiosities": "Distribuição: Venezuela, Bolívia, Paraguai e Brasil.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "3fe16b01-6b09-4ac2-8b84-9a65613cbbcc",
        "lat": -23.108611,
        "lng": -50.359444,
        "data": "13/08/2021"
      }
    ]
  },
  {
    "id": "aae069c5-e64c-40bd-a092-445999a9c9b7",
    "specie": {
      "name": "Canário-da-terra",
      "scientific_name": "Sicalis flaveola",
      "family": "Thraupidae",
      "order": "Passeriformes",
      "habitat": "Campos secos, campos de cultura, caatinga, bordas de matas, cerrado, campos naturais, pastagens abandonadas, plantações e jardins gramados.",
      "food": "Sementes no chão, predominantemente granívoro.",
      "habits": "Fica em bandos fora do período de acasalamento. Macho canta de madrugada de forma extensa e áspera.",
      "curiosities": "Distribuição: Maranhão ao Rio Grande do Sul, oeste até Mato Grosso, também Guianas, Venezuela, Colômbia, Equador, Peru, Bolívia, Paraguai, Uruguai e Argentina.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    }
  },
  {
    "id": "67083754-5409-4439-8c8a-c51ae67d52e3",
    "specie": {
      "name": "Choca-barrada",
      "scientific_name": "Thamnophilus doliatus",
      "family": "Thamnophilidae",
      "order": "Passeriformes",
      "habitat": "Capoeiras, bordas de mata ciliar, cerradões e matas secas, raramente vegetação alta.",
      "food": "Insetívoro.",
      "habits": "Aproxima-se do ser humano, adapta-se a áreas alteradas, presença em cidades atualmente comum.",
      "curiosities": "Distribuição: maior parte do Brasil, ausente apenas no Nordeste e algumas partes da Amazônia Central.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "660303af-8212-43b0-af69-1170d701b8cb",
        "lat": -23.108333,
        "lng": -50.353333,
        "data": "24/06/2021"
      }
    ]
  },
  {
    "id": "51cab57f-4bc5-4609-ae1a-4ed1c6f4963f",
    "specie": {
      "name": "Coleirinho",
      "scientific_name": "Sporophila caerulescens",
      "family": "Thraupidae",
      "order": "Passeriformes",
      "habitat": "Campos abertos e capinzais.",
      "food": "Granívoro.",
      "habits": "Fora do período reprodutivo vive em grupos de 6 a 20 indivíduos, às vezes mistos com outras espécies de papa-capins e tizius.",
      "curiosities": "Distribuição: todo o Brasil, exceto parte florestal da Amazônia, ocorrendo também em áreas urbanas.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "46d1ddbb-84cd-4259-84b3-2ff20805f71a",
        "lat": -23.108889,
        "lng": -50.354167,
        "data": "21/10/2021"
      }
    ]
  },
  {
    "id": "4bd545c7-26eb-4e0a-8c01-374cf2e4d19d",
    "specie": {
      "name": "Curicaca",
      "scientific_name": "Theristicus caudatus",
      "family": "Threskiornithidae",
      "order": "Pelecaniformes",
      "habitat": "Campos secos, alagados e pastagens.",
      "food": "Artrópodes e outros invertebrados.",
      "habits": "Vive em bandos pequenos ou solitário, é diurna e crepuscular, empoleira-se à noite e gosta de planar a grandes alturas.",
      "curiosities": "Seu bico longo e curvo é adaptado para extrair larvas de besouros e outros insetos da terra fofa. Distribuição: grande parte do Brasil, Paraguai, norte da Argentina, norte do Uruguai e parte da Bolívia.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "904d6d5c-1423-41a3-9d9e-846f589d2e8f",
        "lat": -23.106667,
        "lng": -50.351667,
        "data": "15/07/2021"
      }
    ]
  },
  {
    "id": "b3aa9204-432f-4800-9516-9e15baead09d",
    "specie": {
      "name": "Saí-canário",
      "scientific_name": "Thlypopsis sordida",
      "family": "Thraupidae",
      "order": "Passeriformes",
      "habitat": "Formações florestais secundárias e cidades arborizadas, ocupando estratos médios e altos da floresta, raramente vai ao chão.",
      "food": "Frutos, sementes e insetos capturados na folhagem.",
      "habits": "Solitário, em pares no período reprodutivo. Em agosto e setembro formam-se grupamentos de até 8 aves, possivelmente migrantes do Pantanal para o sul.",
      "curiosities": "Distribuição: ampla na América do Sul e no Brasil, também Colômbia, Equador, Peru, Bolívia, Paraguai e Argentina.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "f15c7c48-19f6-403c-9725-c4f451b3f9c3",
        "lat": -23.108333,
        "lng": -50.353333,
        "data": "27/05/2021"
      }
    ]
  },
  {
    "id": "8e5e6c6e-58eb-4a32-82d6-b35f48a874de",
    "specie": {
      "name": "Saíra-de-chapéu-preto",
      "scientific_name": "Nemosia pileata",
      "family": "Thraupidae",
      "order": "Passeriformes",
      "habitat": "Regiões com vegetação arbórea rala como caatinga e cerrado.",
      "food": "Frutinhas das árvores e arbustos, epífitas, pedaços de frutas, suco, folhas, botões e néctar.",
      "habits": "Macho e fêmea geralmente juntos, raramente em grupos ou com outras aves.",
      "curiosities": "Distribuição: praticamente todo o Brasil, exceto extremo sul e noroeste do Amazonas, também Guianas, Venezuela, Bolívia, Paraguai e Argentina.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "62da7c27-1c3a-44af-a6fc-a599333bc5be",
        "lat": -23.105833,
        "lng": -50.360833,
        "data": "25/06/2021"
      }
    ]
  },
  {
    "id": "0fc025a2-1025-4687-955a-432d8971992b",
    "specie": {
      "name": "Sanhaço-cinzento",
      "scientific_name": "Thraupis sayaca",
      "family": "Thraupidae",
      "order": "Passeriformes",
      "habitat": "Habita matas abertas, capões, matas ciliares, zonas de cultivo, matas degradadas ou em recuperação, e até mesmo jardins e parques urbanos, tolerando climas de úmidos a semiáridos, vive na copa ou entre as árvores à busca de alimentos.",
      "food": "Se alimenta de frutos, folhas, brotos, flores de eucaliptos e insetos.",
      "habits": "Anda quase sempre em casais ou pequenos bandos, também é visto junto com outra espécie de sua família. É bem ativo e costuma ter medo de humanos. Quando um macho apronta-se para agredir outro, seu canto torna-se rouco e monótono.",
      "curiosities": "Distribuição: regiões tropicais e subtropicais ao sul da Amazônia e a leste dos Andes. Autor das fotos: Lucas Cordeiro C. Silva.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "d8943ff8-f004-49b2-a82a-c9906b04953b",
        "lat": -23.107778,
        "lng": -50.359444,
        "data": "03/06/2021"
      }
    ]
  },
  {
    "id": "7f19fffe-fc03-4ccd-aa87-f2a504fae6df",
    "specie": {
      "name": "Tico-tico-rei",
      "scientific_name": "Coryphospingus cucullatus",
      "family": "Thraupidae",
      "order": "Passeriformes",
      "habitat": "Vive em bordas de matas secundárias, cerrados, campos, cafezais e pomares, geralmente em locais sombreados, capoeiras ralas e baixas.",
      "food": "Se alimenta de sementes, brotos, frutas, insetos.",
      "habits": "Comportamento discreto e solitário, o macho só exibe completamente seu belo topete quando está excitado ou ao cantar.",
      "curiosities": "Eventualmente é capturado e criado como ave de cativeiro. Presente no Brasil no Leste do Pará, Mato Grosso, Goiás ao oeste de Minas Gerais, Rio de Janeiro, São Paulo, Paraná, Santa Catarina e Rio Grande do Sul. Autor das fotos: Lucas Cordeiro C. Silva.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "388105aa-14cb-44f2-8ad9-797714c22205",
        "lat": -23.109167,
        "lng": -50.360278,
        "data": "30/07/2021"
      }
    ]
  },
  {
    "id": "d33c3f4c-3b03-4f7c-86b1-dd51d58626c6",
    "specie": {
      "name": "Beija-flor-tesoura",
      "scientific_name": "Eupetomena macroura",
      "family": "Trochilidae",
      "order": "Apodiformes",
      "habitat": "Vive em áreas semiabertas, bordas de florestas, capoeiras, parques e jardins, sendo comum até em grandes metrópoles.",
      "food": "Se alimenta basicamente de néctar de flores, mas também caça pequenos insetos.",
      "habits": "Não costuma ter medo do ser humano, aproximando-se das pessoas para se alimentar nas garrafas com água e açúcar ou nas flores de seus jardins. É territorialista e extremamente agressivo, principalmente na época da reprodução.",
      "curiosities": "Em algumas épocas do ano, quando há menos disponibilidade de néctar, adota uma única árvore, que pode ser um mulungu ou um ipê. Autor das fotos: Lucas Cordeiro C. Silva. Ocorre das Guiana à Bolívia e Paraguai, todo o Brasil, exceto certas regiões da Amazônia.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "218385aa-16f8-41b8-a357-82aa54754c0b",
        "lat": -23.107778,
        "lng": -50.359444,
        "data": "03/06/2021"
      }
    ]
  },
  {
    "id": "19f28952-f286-4ded-930e-30c98c59e317",
    "specie": {
      "name": "Besourinho-de-bico-vermelho",
      "scientific_name": "Chlorostilbon lucidus",
      "family": "Trochilidae",
      "order": "Apodiformes",
      "habitat": "Vive em jardins e quintais floridos, capoeiras ralas, áreas abertas e matas de candeias floridas.",
      "food": "Se alimenta quase que exclusivamente em voo e é adaptado para sugar o néctar das flores, também come insetos e aranhas.",
      "habits": "Tem necessidade de limpar-se frequentemente devido ao constante contato com o líquido viscoso das flores. Gosta de tomar banho de sol e se espreguiça após o descanso. Pousa abertamente em galhos finos para dormir. Durante as horas da sua maior atividade é muito agressivo.",
      "curiosities": "Autor das fotos: Lucas Cordeiro C. Silva. Pode ser encontrado no Nordeste e do Espírito Santo ao Rio Grande do Sul.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "b24d2939-5fc6-4ad1-8a73-aa4e88691f5f",
        "lat": -23.108333,
        "lng": -50.353333,
        "data": "12/08/2021"
      }
    ]
  },
  {
    "id": "d082272b-a1cd-42ac-b8b0-900afa24daee",
    "specie": {
      "name": "Guaracavuçu",
      "scientific_name": "Cnemotriccus fuscatus",
      "family": "Tyrannidae",
      "order": "Passeriformes",
      "habitat": "É comum no sub-bosque de florestas baixas, bordas de florestas, florestas de galeria, capoeiras arbustivas, arbustos e na vegetação arbórea baixa em ilhas fluviais.",
      "food": "Captura insetos em voos curtos.",
      "habits": "Seu comportamento é muito calmo e pouco visível. Muito arisco, ao perceber um intruso nas proximidades do ninho voa para longe e só retorna depois que o intruso desaparece.",
      "curiosities": "Autor das fotos: Lucas Cordeiro C. Silva. Praticamente todo o Brasil e demais países da América do Sul, exceto Chile e Uruguai.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "91ee04d8-bb74-4e22-8374-9d31f36df463",
        "lat": -23.108333,
        "lng": -50.353333,
        "data": "25/06/2021"
      }
    ]
  },
  {
    "id": "cc797564-a3cb-472b-a001-0b13130be3dd",
    "specie": {
      "name": "Peitica",
      "scientific_name": "Empidonomus varius",
      "family": "Tyrannidae",
      "order": "Passeriformes",
      "habitat": "Vive em bordas de matas, capoeiras, clareiras em florestas primárias, cerradões e outras formações com árvores de tamanho médio, mas não muito fechadas.",
      "food": "Se alimenta basicamente de insetos que apanha em voos curtos e também de pequenas frutinhas.",
      "habits": "De hábitos migratórios. Seu canto é um chamado abafado, emitido em pousos tradicionais na copa.",
      "curiosities": "Autor das fotos: Lucas Cordeiro C. Silva. Ocorre a leste dos Andes da Argentina até os Estados Unidos, realizando migrações sazonais, deslocando-se para latitudes mais baixas no inverno.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "ce3cfaa1-ba4c-4484-9f9e-507933a446b5",
        "lat": -23.110556,
        "lng": -50.362222,
        "data": "07/10/2021"
      }
    ]
  },
  {
    "id": "b7a35c5f-cf7d-49e4-8547-d2801640ba34",
    "specie": {
      "name": "Sabiá-barranco",
      "scientific_name": "Turdus leucomelas",
      "family": "Turdidae",
      "order": "Passeriformes",
      "habitat": "Comum em todas as matas ciliares, matas de galeria, matas secas, cambarazais e cerradões, acostuma-se com ambientes criados pela ação humana, como jardins, pomares e áreas urbanas bem arborizadas.",
      "food": "Se alimenta basicamente de minhocas e artrópodes, revira as folhas caídas em busca de pequenos invertebrados e também se alimenta de pequenos frutos.",
      "habits": "Canta somente na primavera, época em que acasala. Adaptável a diferentes ambientes e muito visto em parques urbanos com vegetação densa. Sua voz é múltipla, com um canto contínuo, durante o resto do ano só emite vocalizações de alerta, especialmente ao entardecer.",
      "curiosities": "Autor das fotos: Lucas Cordeiro C. Silva. Encontrado em todo o Brasil.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "d773f9a6-5d99-463b-a784-3e064d2f4a49",
        "lat": -23.107778,
        "lng": -50.359444,
        "data": "29/07/2021"
      }
    ]
  },
  {
    "id": "580df10b-2fae-4df2-8b16-eaf35bb2aa24",
    "specie": {
      "name": "Sabiá-poca",
      "scientific_name": "Turdus amaurochalinus",
      "family": "Turdidae",
      "order": "Passeriformes",
      "habitat": "Espécie semiflorestal, adapta-se também a áreas urbanas muito arborizadas, também é visto em bordas de matas e clareiras.",
      "food": "Se alimenta de invertebrados e pequenos frutos, principalmente no solo.",
      "habits": "Pousado ou no chão, possuem o característico hábito de balançar a cauda rapidamente na vertical. Só canta na época de reprodução, fora disso só emite chamados.",
      "curiosities": "Período migratório vai de maio a agosto. Autor das fotos: Lucas Cordeiro C. Silva. Ocorrência em quase todos os estados do Brasil e na Argentina.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "0b8a518e-b909-451e-8e48-3a866637f87e",
        "lat": -23.110556,
        "lng": -50.362222,
        "data": "18/06/2021"
      }
    ]
  },
  {
    "id": "7890a19d-73e7-4f2f-9ebb-3102814f55de",
    "specie": {
      "name": "Tucão",
      "scientific_name": "Elaenia obscura",
      "family": "Tyrannidae",
      "order": "Passeriformes",
      "habitat": "Frequenta florestas úmidas da Mata Atlântica e também matas de galeria, matas mesófilas e matas de araucária.",
      "food": "Sua dieta é essencialmente frugívora.",
      "habits": "Constrói ninhos bem elaborados em forma de taça externamente decorados com líquens para camuflagem, nas forquilhas de árvores e arbustos, chocando ovos pintalgados.",
      "curiosities": "Autor das fotos: Lucas Cordeiro C. Silva. Encontrado nas regiões Sudeste e Sul do Brasil, além de Bolívia, Equador, Paraguai, Peru, Uruguai e Argentina.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "32771df9-922b-4997-9594-035409229c26",
        "lat": -23.110556,
        "lng": -50.362222,
        "data": "30/07/2021"
      }
    ]
  },
  {
    "id": "9c84b803-fd4c-4bdb-b308-1d5adbc8bb6a",
    "specie": {
      "name": "Bem-te-vi-rajado",
      "scientific_name": "Myiodynastes maculatus",
      "family": "Tyrannidae",
      "order": "Passeriformes",
      "habitat": "Habita a parte interna das matas ciliares, cerradões, cambarazais e matas secas, ocasionalmente áreas de cerrado denso. Não costuma ficar em poleiros expostos.",
      "food": "Se alimenta de insetos que apanha em voo a partir do poleiro e também de pequenos frutos.",
      "habits": "Vive em casais ou grupos familiares, muito agressivos com outros bem-te-vis-rajados. Chamado de contato parecido com soluço agudo, levemente anasalado, repetido várias vezes. Passa a maior parte do tempo pousado nas árvores das bordas de matas secundárias.",
      "curiosities": "Realiza migrações sazonais, indo para latitudes mais baixas no inverno. Autor das fotos: Lucas Cordeiro C. Silva. Ocorre desde o México até a Argentina, presente em todos os países sul-americanos, exceto o Chile.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "4938516f-d0c6-4ba2-8ef0-6b27d16bd9b7",
        "lat": -23.110556,
        "lng": -50.362222,
        "data": "09/09/2021"
      }
    ]
  },
  {
    "id": "bc680585-3ae2-4761-896f-25dca5fe77b2",
    "specie": {
      "name": "Bentevizinho-de-penacho-vermelho",
      "scientific_name": "Myiozetetes similis",
      "family": "Tyrannidae",
      "order": "Passeriformes",
      "habitat": "Prefere matas ou capoeiras mais conservadas, quase sempre próximo a algum curso d'água; não se adapta muito às regiões campestres ou cidades pouco arborizadas.",
      "food": "Alimenta-se de insetos capturados durante pequenos vôos e de pequenas frutas.",
      "habits": "Ocorre aos pares ou em pequenos grupos familiares, que são muito barulhentos. Indivíduos em regiões de clima mais severo podem migrar para regiões mais quentes no inverno.",
      "curiosities": "Autor das fotos: Lucas Cordeiro C. Silva. Distribui-se em grande parte do Brasil, em alguns países vizinhos da América do Sul e também na América Central.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "4c7db977-4a31-41fb-9959-c03ebcd8522e",
        "lat": -23.108611,
        "lng": -50.3614503,
        "data": "18/06/2021"
      }
    ]
  },
  {
    "id": "5a811d68-7df2-4978-9e62-872cb016dd4f",
    "specie": {
      "name": "Lavadeira-mascarada",
      "scientific_name": "Fluvicola nengeta",
      "family": "Tyrannidae",
      "order": "Passeriformes",
      "habitat": "O seu habitat é junto a rios ou lagoas, podendo ser encontrada em parques e jardins urbanos. Frequentemente vai ao chão, mesmo barrento, em busca de alimento.",
      "food": "Se alimenta de pequenos artrópodes capturados na lama das margens de rios, açudes, brejos e pocilgas.",
      "habits": "Ave de espaços abertos, comum em bandos ou casais. Ocasionalmente encontrada em áreas urbanas bem arborizadas. Tem o hábito de bater o alimento contra o chão antes de consumi-lo.",
      "curiosities": "Na década de 90 foram feitos os primeiros registros da espécie no interior de São Paulo. Em Natal/RN, evita-se sua caça e captura porque há o costume de que esse pássaro “lavou a roupa de Deus”. Autor das fotos: Lucas Cordeiro C. Silva. Existem duas populações muito distantes, uma no leste brasileiro e outra no noroeste da América do Sul.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "32dde023-5b37-4082-8f4a-48f92ee4c9e4",
        "lat": -23.1075,
        "lng": -50.350833,
        "data": "25/06/2021"
      }
    ]
  },
  {
    "id": "40956d99-f135-4af9-b7dc-f8b901e2047c",
    "specie": {
      "name": "Neinei",
      "scientific_name": "Megarynchus pitanguá",
      "family": "Tyrannidae",
      "order": "Passeriformes",
      "habitat": "Encontrado em florestas, paisagens abertas com árvores esparsas, cerrados e áreas urbanas arborizadas, de preferência onde haja água.",
      "food": "Se alimenta de insetos e frutinhas.",
      "habits": "Ave migratória, encontrada nos meses mais quentes. O casal tem o hábito de cantar em dueto, mal sincronizado. Muito tímido, é mais fácil ouvir do que ver.",
      "curiosities": "Apesar de viver praticamente sozinho, pode ser visto em casal ou em um bando de três indivíduos. Autor das fotos: Lucas Cordeiro C. Silva. Ocorre do México à Argentina e em todo o Brasil.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "cd8532c8-0d34-4959-b8ef-5f47b3162919",
        "lat": -23.107778,
        "lng": -50.359444,
        "data": "12/08/2021"
      }
    ]
  },
  {
    "id": "0e43ecf5-bdf5-4771-987b-098858754a2d",
    "specie": {
      "name": "Príncipe",
      "scientific_name": "Pyrocephalus rubinus",
      "family": "Tyrannidae",
      "order": "Passeriformes",
      "habitat": "Vive em campos e cerrados. Ocupa ambientes abertos, desde campos, praias de rio com arbustos, até cerrado e bordas de vegetação florestal.",
      "food": "Se alimenta de insetos capturados no ar ou no solo, retornando ao poleiro.",
      "habits": "Não penetra em áreas com adensamento de vegetação. Utiliza ambientes criados pelos humanos, sendo notável em jardins e parques urbanos. Normalmente encontrado aos pares.",
      "curiosities": "Reproduz-se no sul do Brasil e países vizinhos (Uruguai, Argentina) e, após o ciclo reprodutivo, migra para o norte, chegando até a Amazônia. Autor das fotos: Lucas Cordeiro C. Silva. Encontrado no sudeste da Bolívia, Paraguai e do sudeste do Brasil até a Argentina e Uruguai.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "a75a46c8-606e-484d-a5fb-fa051fa9a5ed",
        "lat": -23.110556,
        "lng": -50.362222,
        "data": "03/06/2021"
      }
    ]
  },
  {
    "id": "93b59fb7-3e7a-412d-ba20-fc3e45606664",
    "specie": {
      "name": "Suiriri",
      "scientific_name": "Tyrannus melancholicus",
      "family": "Tyrannidae",
      "order": "Passeriformes",
      "habitat": "Adapta-se até aos maiores conglomerados urbanos, desde que haja alguma arborização.",
      "food": "Se alimenta de insetos e frutos, capturando-os no ar e retornando ao poleiro, muitas vezes batendo fortemente para matá-los ou estonteá-los.",
      "habits": "Costuma ficar pousado em poleiros expostos. Vive solitário ou em casais, muito agressivo entre si. Canta frequentemente do final da madrugada ao início da noite.",
      "curiosities": "Algumas populações migratórias possuem asas mais pontudas, adaptadas para voos longos. Autor das fotos: Lucas Cordeiro C. Silva. Ocorre em todo o Brasil e desde os Estados Unidos a quase toda a América do Sul.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. <http://www.wikiaves.com.br/>"
    },
    "coordinates": [
      {
        "id": "5089c8b4-1bec-4a34-bd89-c244f3ba51bc",
        "lat": -23.107778,
        "lng": -50.359444,
        "data": "23/09/2021"
      }
    ]
  },
  {
    "id": "2a5c7180-4a6d-4849-b7c8-0b5e12231f7d",
    "specie": {
      "name": "Alma-de-gato",
      "scientific_name": "Piaya cayana",
      "family": "Cuculidae",
      "order": "Cuculiformes",
      "habitat": "Ocorre em matas ciliares, matas secundárias, parques e bairros arborizados até mesmo das maiores cidades brasileiras. Habita os estratos médio e superior dessas matas, deslocando-se através da copa das árvores e arbustos, quase nunca descendo ao solo.",
      "food": "Alimenta-se basicamente de insetos, principalmente lagartas, que captura ao examinar as folhas, inclusive em suas partes inferiores.",
      "habits": "Lembra muito os esquilos pelo modo como pula entre as ramagens com sua longa cauda. Costuma imitar o chamado de alerta ou perigo de algumas aves como o bem-te-vi (Pitangus sulphuratus) e Maria-cavaleira (Myiarchus ferox) para capturar insetos que se desprendem da ramaria. Anda sozinho ou aos pares.",
      "curiosities": "Na primavera, início do período reprodutivo, canta incansavelmente durante todo o dia. Autor das fotos: Lucas Cordeiro C. Silva. Ocorre em todo o Brasil e tem uma vasta distribuição na América Latina.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. Disponível em: <http://www.wikiaves.com.br/>."
    },
    "coordinates": [
      {
        "id": "3e32ce06-706c-447e-aca8-74c726d7bcf9",
        "lat": -23.1075,
        "lng": -50.359722,
        "data": "16/07/2021"
      }
    ]
  },
  {
    "id": "1d010691-7c4d-4711-941b-ae594b764a28",
    "specie": {
      "name": "Anu-branco",
      "common_names": [
        "rabo-de-palha",
        "alma-de-gato",
        "quiriru",
        "pelincho"
      ],
      "scientific_name": "Guira guira",
      "family": "Cuculidae",
      "order": "Cuculiformes",
      "habitat": "Campos, lavouras e ambientes mais abertos.",
      "food": "Se alimenta preferencialmente de invertebrados e de pequenos vertebrados, eventualmente pode se alimentar de frutas e sementes em épocas de seca, e quando há escassez de recursos pode se alimentar de artrópodes.",
      "habits": "Gosta de tomar sol e banhar-se na poeira, muitas vezes adquire plumagem fortemente tingida com a cor da terra do local.",
      "curiosities": "Autor das fotos: Lucas Cordeiro C. Silva. Ocorre do sudeste do Amapá e do estuário amazônico à Bolívia, Argentina e Uruguai.",
      "division": "1",
      "reference": "GHERARD, B.; Maciel, R. Guia de Aves. Fundação Ezequiel Dias. Belo Horizonte: Imprensa Oficial, 2015. p. 8"
    },
    "coordinates": [
      {
        "id": "323c4930-c13a-41af-8934-527a2607c7e9",
        "lat": -23.108333,
        "lng": -50.359167,
        "data": "03/06/2021"
      }
    ]
  },
  {
    "id": "3274f267-e4a3-449e-8c35-a8b04e428f58",
    "specie": {
      "name": "Bem-te-vi",
      "scientific_name": "Pitangus sulphuratus",
      "family": "Tyrannidae",
      "order": "Passeriformes",
      "habitat": "Podem ser encontrados em áreas urbanas, matas densas e ambientes aquáticos como lagoas, rios e praias.",
      "food": "É insetívoro, mas também come frutas, ovos e até mesmo filhotes de outros pássaros, flores de jardins, minhocas, pequenas cobras, lagartos, crustáceos, peixes, girinos de rios e lagos e pequenos roedores. Costuma comer parasitas (carrapatos) de bovinos e equinos.",
      "habits": "É agressivo, ameaçando qualquer um que se aproxima de seu 'território'. Costuma pousar em lugares salientes como postes e topos de árvores. É um dos primeiros a cantar ao amanhecer. Anda geralmente sozinho, mas pode ser visto em grupos de três ou quatro.",
      "curiosities": "Autor das fotos: Lucas Cordeiro C. Silva. É ave típica da América Latina, predominantemente do sul do México à Argentina, também ser encontrado no sul do Texas e na ilha de Trinidad.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. Disponível em: <http://www.wikiaves.com.br/>."
    },
    "coordinates": [
      {
        "id": "4610229e-4046-4b2d-8b5f-1a54762d450c",
        "lat": -23.110556,
        "lng": -50.362222,
        "data": "03/06/2021"
      }
    ]
  },
  {
    "id": "75dce6f5-bf31-408d-af52-858c3c7a79d3",
    "specie": {
      "name": "Cambacica",
      "scientific_name": "Coereba flaveola",
      "family": "Thraupidae",
      "order": "Passeriformes",
      "habitat": "Tem uma grande variedade de hábitats abertos e semiabertos, arborizados, onde existam flores, inclusive em quintais, podendo se acostumar com a presença humana.",
      "food": "Se alimenta de néctar, frutas e artrópodes.",
      "habits": "Vive solitária ou aos pares e é bastante ativa, mas também pode ser vista em pequenos bandos. Toma banho muitas vezes por causa do contato com o néctar pegajoso.",
      "curiosities": "Seu canto é relativamente forte, simples, monótono, e emitido incansavelmente, canta a qualquer hora do dia e em qualquer época do ano. A fêmea também canta, mas pouco. São muito briguentas, chegando a cair engalfinhadas no solo, onde continuam a luta. Autor das fotos: Lucas Cordeiro C. Silva. Ocorre em quase todas as regiões do país, podendo estar ausente nas regiões extensivamente florestadas, como no oeste e centro da Amazônia. É encontrada desde o México, América Central e Caribe e em todos os países da América do Sul, com exceção do Chile e Uruguai.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. Disponível em: <http://www.wikiaves.com.br/>."
    },
    "coordinates": [
      {
        "id": "95afc240-cf6f-45a0-8bd1-e8c51cc6f832",
        "lat": -23.110556,
        "lng": -50.362222,
        "data": "04/06/2021"
      }
    ]
  },
  {
    "id": "e7c62171-afad-45c9-bb37-3d4e0f5323e5",
    "specie": {
      "name": "Choró-boi",
      "scientific_name": "Taraba major",
      "family": "Thamnophilidae",
      "order": "Passeriformes",
      "habitat": "Presente nas matas ciliares dos rios, corixos e baías, bem como nos cerradões, cambarazais e matas secas.",
      "food": "Insetívoro.",
      "habits": "Demarca o território com um canto de notas graves, um pouco afastadas entre si no início e aceleradas do meio para o final. Macho e fêmea emitem o canto, respondendo entre si e até a uma imitação razoável do chamado.",
      "curiosities": "Autor das fotos: Lucas Cordeiro C. Silva. Presente desde o extremo norte do País até o estado do Paraná, também encontrado do México ao Panamá e em praticamente toda a América do Sul, com exceção do Chile.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. Disponível em: <http://www.wikiaves.com.br/>."
    },
    "coordinates": [
      {
        "id": "8bc9371b-a093-4a6e-8737-9bdf695333db",
        "lat": -23.110556,
        "lng": -50.362222,
        "data": "15/07/2021"
      }
    ]
  },
  {
    "id": "7c022125-5f6b-40e8-bb1b-c921dc142bbc",
    "specie": {
      "name": "Gavião-carijó",
      "scientific_name": "Rupornis magnirostris",
      "family": "Accipitridae",
      "order": "Accipitriformes",
      "habitat": "Vive em casais e constroem um ninho de gravetos revestido por folhas com cerca de meio metro de diâmetro, geralmente no topo de uma árvore grande.",
      "food": "Carnívoro, se alimenta geralmente de aves, ratos e lagartos.",
      "habits": "Costuma voar em casais, fazendo movimentos circulares enquanto os dois vocalizam em dueto. Possui o hábito de utilizar o mesmo poleiro de caça por longo tempo. Passou a se tornar mais comum nos centros urbanos, adaptando-se com sucesso a este ambiente.",
      "curiosities": "Autor das fotos: Lucas Cordeiro C. Silva. Ocorre do México à Argentina e em todo o Brasil.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. Disponível em: <http://www.wikiaves.com.br/>."
    },
    "coordinates": [
      {
        "id": "3e0323ab-4c27-4aec-97b1-a78ba7ea604e",
        "lat": -23.107778,
        "lng": -50.359444,
        "data": "03/06/2021"
      }
    ]
  },
  {
    "id": "ed64df57-7273-4d97-9e01-f4e110268429",
    "specie": {
      "name": "João-de-barro",
      "scientific_name": "Furnarius rufus",
      "family": "Furnariidae",
      "order": "Passeriformes",
      "habitat": "Comum em paisagens abertas, como campos, cerrados, pastagens, ao longo de rodovias, bairros arborizados e em jardins.",
      "food": "Formigas, içás, cupins, larvas, aranhas e outros artrópodes, dificilmente se alimenta de sementes, também se alimenta de outros invertebrados.",
      "habits": "Caminha pelo chão em busca de insetos, frequentemente pousando em postes, cercas, galhos isolados e outros pontos que permitam uma boa visão dos arredores. Vive geralmente aos casais. Canta em dueto (macho e fêmea juntos) os arredores do ninho, em postura altiva e tremulando as asas, com um canto extremamente estridente.",
      "curiosities": "Há várias lendas sobre esta espécie, como a de que se o macho for traído ele poderia trancar a fêmea no ninho até que ela morra; tal comportamento nunca foi registrado cientificamente. Autor das fotos: Lucas Cordeiro C. Silva. Ocorre nas regiões Sul, Sudeste e Centro-oeste, estados de Goiás, Piauí, Pernambuco e Alagoas, encontrado também na Argentina, Paraguai, Uruguai e Bolívia.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. Disponível em: <http://www.wikiaves.com.br/>."
    },
    "coordinates": [
      {
        "id": "b29c801f-7b6f-4edf-be11-cbfd9aeb4f63",
        "lat": -23.107778,
        "lng": -50.359444,
        "data": "03/06/2021"
      }
    ]
  },
  {
    "id": "e882b554-f4f7-4d61-abff-482c01d2ca24",
    "specie": {
      "name": "Maria-faceira",
      "scientific_name": "Syrigma sibilatrix",
      "family": "Ardeidae",
      "order": "Pelecaniformes",
      "habitat": "Habita campos, pampas, plantações, cerrados, savanas de cupins e varjões. No Sudeste, aparece próximo à orla marítima, nos campos litorâneos e nas fazendas.",
      "food": "Insetívoro.",
      "habits": "Desloca-se para dormir pousada em árvores altas, geralmente em terreno seco. No início da manhã retorna ao local de alimentação, onde permanece no solo a maior parte do tempo, caçando insetos em caminhadas lentas.",
      "curiosities": "Na época da reprodução, o macho tem um voo de exibição na frente da fêmea, voando para frente e para trás e deslizando em círculos. Autor das fotos: Lucas Cordeiro C. Silva. Ocorre da Venezuela e Colômbia ao Brasil, Paraguai, Bolívia e Argentina, com duas populações distintas, separadas pela bacia amazônica.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. Disponível em: <http://www.wikiaves.com.br/>."
    },
    "coordinates": [
      {
        "id": "c3006683-d07c-4fe4-9089-4b4ede094dd2",
        "lat": -23.107222,
        "lng": -50.358056,
        "data": "19/06/2021"
      }
    ]
  },
  {
    "id": "364b6885-6239-4aca-81d6-a0ad43cc3f59",
    "specie": {
      "name": "Pica-pau-verde-barrado",
      "scientific_name": "Colaptes melanochloros",
      "family": "Picidae",
      "order": "Piciformes",
      "habitat": "Vive em matas de galeria, cerrados, cerradões, caatingas, campos com árvores e na borda de florestas, e está cada vez mais comum nas áreas urbanas.",
      "food": "Insetívoro.",
      "habits": "No período reprodutivo (a partir de julho), os machos iniciam a temporada de canto territorial, uma vocalização intensa e contínua, especialmente nos períodos matinais. Escolhe alguns pousos tradicionais em galhos altos, onde pode cantar durante dias, emitindo uma risada alta parecida com a do pica-pau-do-campo.",
      "curiosities": "Para demarcar território e comunicar-se entre machos e fêmeas, executa tamborilações, batendo com o bico em paus secos, cascas salientes, troncos ocos e até chapas de aço. Autor das fotos: Lucas Cordeiro C. Silva. Ocorre desde o Amazonas (ilha de Marajó) até o Rio Grande do Sul, e para oeste até o Mato Grosso, também encontrado no Paraguai, Argentina e Uruguai.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. Disponível em: <http://www.wikiaves.com.br/>."
    },
    "coordinates": [
      {
        "id": "8a629aae-04a2-4c8e-9e68-0933cda3de60",
        "lat": -23.110556,
        "lng": -50.362222,
        "data": "15/07/2021"
      }
    ]
  },
  {
    "id": "c2f44bcc-6185-457f-ac88-8dff827f6d14",
    "specie": {
      "name": "Quero-quero",
      "scientific_name": "Vanellus chilensis",
      "family": "Charadriidae",
      "order": "Charadriiformes",
      "habitat": "Grandes campinas úmidas, espraiados dos rios e lagoas e pastagens.",
      "food": "Se alimenta de invertebrados aquáticos e peixinhos que encontra na lama, também se alimenta de artrópodes e moluscos terrestres.",
      "habits": "É sempre o primeiro a dar o alarme quando algum intruso invade seus domínios. Ave briguenta que provoca rixa com outras espécies na mesma campina.",
      "curiosities": "As capivaras tiram proveito da convivência com o quero-quero, interpretando seus gritos como alerta de perigo. Autor das fotos: Lucas Cordeiro C. Silva. Ocorre desde a Argentina e leste da Bolívia até a margem direita do baixo Amazonas, no Brasil.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. Disponível em: <http://www.wikiaves.com.br/>."
    },
    "coordinates": [
      {
        "id": "787a95e0-5db9-4e80-94fe-20b3468c803d",
        "lat": -23.107778,
        "lng": -50.359444,
        "data": "03/06/2021"
      }
    ]
  },
  {
    "id": "1e4db909-0a4c-4fb3-9e9b-29a557c7b208",
    "specie": {
      "name": "Pintassilgo",
      "scientific_name": "Spinus magellanicus",
      "family": "Fringillidae",
      "order": "Passeriformes",
      "habitat": "Vive em mata secundária aberta, árvores em plantações e quintais, pinhais e cerrados.",
      "food": "Alimenta-se de sementes, principalmente sementes de flores e pequenos frutos secos de revestimento duro.",
      "habits": "Nidifica nas copas das araucárias mais altas ou em cafeeiros. A fêmea constrói o ninho em forma de pequena tigela e realiza a incubação, podendo o macho alimentá-la durante esse período.",
      "curiosities": "Ave canora que se tornou rara devido à intensa perseguição do comércio clandestino de aves silvestres. Autor das fotos: Lucas Cordeiro C. Silva. Ocorre em praticamente todo o Brasil, exceto na Região Amazônica e Nordeste, também em Colômbia, Equador, Peru, Bolívia, Paraguai, Argentina e Uruguai.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. Disponível em: <http://www.wikiaves.com.br/>."
    },
    "coordinates": [
      {
        "id": "c54fe391-ee27-452a-b9b7-5a27abbf1bf8",
        "lat": -23.11,
        "lng": -50.3625,
        "data": "15/07/2021"
      }
    ]
  },
  {
    "id": "1b03b7a9-99b9-4568-bfac-2232a9aab584",
    "specie": {
      "name": "Quiriquiri",
      "scientific_name": "Falco sparverius",
      "family": "Falconidae",
      "order": "Falconiformes",
      "habitat": "Ocupa áreas semiurbanizadas, margens de estradas e ambientes abertos, produzidos pela atividade humana. Evita matas densas e vegetação adensada.",
      "food": "Alimenta-se de lagartos e grandes insetos; ocasionalmente captura roedores, pequenas cobras, morcegos e aves pequenas.",
      "habits": "Caça a partir de poleiros fixos, naturais ou artificiais, voando a baixa altura do solo e ‘peneirando’ a presa.",
      "curiosities": "Nidifica em ocos de árvores, cavidades feitas por pica-paus, buracos em barrancos e até em cupinzeiros. Autor das fotos: Lucas Cordeiro C. Silva. Ocorre desde o Alasca e norte do Canadá até a ponta sul da América do Sul, e em todo o Brasil, exceto em florestas.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. Disponível em: <http://www.wikiaves.com.br/>."
    },
    "coordinates": [
      {
        "id": "6c78c6a9-2933-42f2-a5a3-9ddb2b158468",
        "lat": -23.106667,
        "lng": -50.351667,
        "data": "30/07/2021"
      }
    ]
  },
  {
    "id": "0d0884f3-6e98-4620-b1de-90b673cd9efb",
    "specie": {
      "name": "Risadinha",
      "scientific_name": "Camptostoma obsoletum",
      "family": "Tyrannidae",
      "order": "Passeriformes",
      "habitat": "Ocorre desde a floresta amazônica até áreas de campos com arbustos de todo o país, adaptando-se a ambientes urbanos com alguma arborização.",
      "food": "Alimenta-se de invertebrados e frutos.",
      "habits": "Desconfiada, movimenta-se bastante, desde a copa das árvores mais destacadas até próximo ao chão. Característica marcante é o canto em sequência de notas agudas, altas, descendentes, que parecem uma risada. Canta desde o amanhecer até o escurecer.",
      "curiosities": "Apresenta período reprodutivo de julho a dezembro. Autor das fotos: Lucas Cordeiro C. Silva. Ocorre em todo o Brasil, também na América Central desde a Costa Rica e demais países Sul Americanos, exceto o Chile, até o centro da Argentina.",
      "division": "1",
      "reference": "WikiAves (2023) WikiAves, a Enciclopédia das Aves do Brasil. Disponível em: <http://www.wikiaves.com.br/>."
    },
    "coordinates": [
      {
        "id": "fae4bbd5-864f-42f3-a87b-b21cd007102b",
        "lat": -23.111111,
        "lng": -50.360556,
        "data": "13/08/2021"
      }
    ]
  }
];

export default dados2;